import React, { useCallback, useState  } from 'react';
import classnames from 'classnames';
import { Transfer } from 'antd';
import difference from 'lodash/difference';
import { ReorderableTable } from '../reorderableTable/ReorderableTable';

import './styles.less';

export const TableTransfer = ( props ) => {
    const {
        sourceColumns = [],
        targetColumns = [],
        direction = 'right',
        reorderable = true,
        onReorder,
        titles,
        loading,
        id,  
        ...otherProps
    } = props;

    const [ doSelect ] = useState( props.selectAll || false );

    const getTableType = useCallback( ( tableDirection ) => {
        return ( tableDirection === 'left' ) ? 'source' : 'target';
    }, [] );

    const classes = classnames( [
        'table-transfer',
        { 'flipped': Boolean( direction === 'left' ) },
        { [ props.className ]: Boolean( props.className ) },
    ] );

    return (
        <Transfer
            { ...otherProps }
            titles={ titles }
            showSelectAll={ doSelect } 
            className={ classes }
        >
            { ( {
                direction: tableDirection,
                filteredItems,
                onItemSelectAll,
                onItemSelect,
                selectedKeys: listSelectedKeys,
                disabled: listDisabled,
            } ) => {
                const tableType = getTableType( tableDirection ); // 'source' or 'target'
                const isSource = ( tableType === 'source' );
                const isTarget = ( tableType === 'target' );

                const columnData = ( isSource ) ? sourceColumns : targetColumns;
                const canReorder = ( reorderable && isTarget );

                const rowSelection = {
                    getCheckboxProps: item => ( { disabled: listDisabled || item.disabled } ),
                    onSelectAll( selected, selectedRows ) {
                        const treeSelectedKeys = selectedRows
                            .filter( item => !item.disabled )
                            .map( ( { key } ) => key );
                        const diffKeys = selected
                            ? difference( treeSelectedKeys, listSelectedKeys )
                            : difference( listSelectedKeys, treeSelectedKeys );
                        onItemSelectAll( diffKeys, selected );
                    },
                    onSelect( { key }, selected ) {
                        onItemSelect( key, selected );
                    },
                    selectedRowKeys: listSelectedKeys,
                };

                return (
                    <ReorderableTable 
                        reorderable={ canReorder }
                        rowSelection={ rowSelection }
                        columns={ columnData }
                        dataSource={ filteredItems }
                        pagination={ false }
                        size="small"
                        showHeader={ false }
                        loading={ loading }
                        selectAll
                        style={ { pointerEvents: listDisabled ? 'none' : null } }
                        onRow={ ( { key, disabled: itemDisabled } ) => ( {
                            onClick: () => {
                                if ( itemDisabled || listDisabled ) {
                                    return;
                                }
                                onItemSelect( key, !listSelectedKeys.includes( key ) );
                            },
                        } ) }
                        onReorder={ onReorder }
                        id={ id }
                    />
                );
            } }
        </Transfer>
    );
};
